import { SET_PROMPTER_ON } from '../actionConstants';

export const setPrompterOnAction = (payload) => {
  return {
    type: SET_PROMPTER_ON,
    payload,
  };
};
